<template>
  <group-buy-block title="拼团记录">
    <template #qrCode>
      <div>
        <ym-button v-if="showFollow"
                   class="btn-follow"
                   size="large"
                   plain
                   @click="handleShowQrPopup"
        >
          <span class="text">关注拼团进度</span>
        </ym-button>
        <qr-code-popup :show.sync="showQrCodePopup"
                       title="关注拼团进度"
                       :src="qrCode.src"
                       :hint="qrCodeHint"
        />
      </div>
    </template>
    <template #list>
      <ul class="member-list">
        <li class="member-item"
            v-for="(item, index) in members"
            :key="index"
        >
          <ym-avatar class="user-avatar"
                     :avatar="item.avatar"
                     :name="item.name"
                     size="small"
          />
          <div class="member-info">
            <div class="role-name-container">
              <ym-tag class="label-leader"
                      v-if="item.role === 'leader'"
                      type="primary"
                      plain
                      size="small"
              >
                团长
              </ym-tag>
              <span class="user-name">{{ item.name }}</span>
            </div>
            <div class="member-desc">
              {{ item.createdTime | formatTime }} {{ item.role === 'leader' ? '发起' : '加入' }}
            </div>
          </div>
        </li>
      </ul>
    </template>
  </group-buy-block>
</template>

<script>
  import { Button, Tag } from '@ymba/ym-ui';
  import GroupBuyBlock from '@/pages/GroupBuy/components/DetailBlock';
  import QrCodePopup from '@/components/QrCodePopup';
  import { isAppWebView, isWeiXinBrowser } from '@/utils';
  import Avatar from '@/components/Avatar';
  import { locationToAppWithRoute } from '@/utils/app-route';

  export default {
    name: 'GroupBuyTeamMemberList',
    components: {
      GroupBuyBlock,
      QrCodePopup,
      'ym-button': Button,
      'ym-avatar': Avatar,
      YmTag: Tag,
    },
    data() {
      return {
        showQrCodePopup: false,
      };
    },
    props: {
      members: {
        type: Array,
        required: true,
      },
      showFollow: {
        type: Boolean,
        required: true,
      },
      qrCode: {
        type: Object,
        required: true,
      },
    },
    computed: {
      qrCodeActionString() {
        return isWeiXinBrowser() ? '长按' : '扫一扫';
      },
      qrCodeHint() {
        return `关注「${this.qrCode.name }」<br>拼团进度实时推送`;
      },
    },
    methods: {
      handleShowQrPopup() {
        if (isAppWebView()) {
          locationToAppWithRoute({
            name: 'AppQrCodeDetail',
            params: {
              qrCode: this.qrCode.src,
              hint: this.qrCodeHint,
            },
          });
          return;
        }
        this.showQrCodePopup = true;
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .member-list {
    padding: 0;
    margin: 0;
    list-style: none;
  }

  .member-item {
    display: flex;
    padding: @size-base 0;

    &:not(:last-child) {
      border-bottom: @border-base;
    }
  }

  .user-avatar {
    flex-shrink: 0;
    margin-right: @size-small;
  }

  .member-info {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 4px 0;
  }

  .role-name-container {
    display: flex;
    align-items: center;
  }

  .label-leader {
    margin-right: @size-extra-small;
  }

  .user-name {
    font-size: @font-size-small;
  }

  .member-desc {
    font-size: @font-size-extra-extra-small;
    color: @color-text-lighter;
  }

  .btn-follow {
    display: block;
    border: 0;
    background: none;
    height: auto;
    padding: @size-base 0;
    text-align: center;

    .text {
      color: @color-text-primary;
      font-size: @font-size-base;
    }
  }
</style>
